@if (!chartReady()) {
<div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
<co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
>
  <div chart-content>
    @if (data()?.chartData?.length) {

    <!-- Conditional Table Rendering -->
    <div class="flex items-center justify-center overflow-x-auto w-full">
      <!-- ICD10 Table -->
      @if (data()?.frequencyTableData?.dischargeIcdColumns?.length) {
      <p-table
        [value]="data().frequencyTableData.rowData"
        [tableStyle]="{ width: '100%' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th
              rowspan="2"
              style="
                background: #0356ad;
                color: #fff;
                font-weight: 600;
                text-align: center;
              "
            >
              {{"ICD10.ADMISSION_ICD10_HOSPITAL_CODE" | translate}}
            </th>
            <th
              [attr.colspan]="
                data().frequencyTableData.dischargeIcdColumns.length
              "
              style="
                background: #919294;
                color: #000;
                font-weight: 600;
                text-align: center;
              "
            >
              {{"ICD10.DISCHARGE_ICD10_HOSPITAL_CODE" | translate}}
            </th>
          </tr>
          <tr>
            @for (h of data().frequencyTableData.dischargeIcdColumns; track
            $index) {
            <th
              style="
                background: #c0c0c0;
                color: #000;
                font-weight: 600;
                text-align: center;
              "
            >
              {{ h }}
            </th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td
              style="
                background: #4e89c5;
                color: #fff;
                font-weight: 600;
                text-align: center;
              "
            >
              {{ row.icd10[0] }}
            </td>
            @for (val of row.icd10.slice(1); track $index) {
            <td style="text-align: center">{{ val }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
      }

      <!-- Ken Table -->
      @if (data()?.frequencyTableData?.dischargeKenColumns?.length) {
      <p-table
        [value]="data().frequencyTableData.rowData"
        [tableStyle]="{ width: '100%' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th
              rowspan="2"
              style="
                background: #0356ad;
                color: #fff;
                font-weight: 600;
                text-align: center;
              "
            >
              {{"REPORTS_COMPONENT.HOSPITAL" | translate}}
            </th>
            <th
              [attr.colspan]="
                data().frequencyTableData.dischargeKenColumns.length
              "
              style="
                background: #919294;
                color: #000;
                font-weight: 600;
                text-align: center;
              "
            >
              {{"REPORTS_COMPONENT.TPA" | translate}}
            </th>
          </tr>
          <tr>
            @for (h of data().frequencyTableData.dischargeKenColumns; track
            $index) {
            <th
              style="
                background: #c0c0c0;
                color: #000;
                font-weight: 600;
                text-align: center;
              "
            >
              {{ h }}
            </th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td
              style="
                background: #4e89c5;
                color: #fff;
                font-weight: 600;
                text-align: center;
              "
            >
              {{ row.kens[0] }}
            </td>
            @for (val of row.kens.slice(1); track $index) {
            <td style="text-align: center">{{ val }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
      }
    </div>

    <!-- Sankey Chart -->
    <div #sankeyWrapper class="flex flex-col items-center">
      <div #sankeyChart id="svg-sankey"></div>
    </div>

    } 
    @else {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    }
  </div>
</co-chart-card>
}
